export default "__VITE_ASSET__VeT7VE3g__"